import { render, staticRenderFns } from "./TfrSignUps.vue?vue&type=template&id=356c54d3&"
import script from "./TfrSignUps.vue?vue&type=script&lang=js&"
export * from "./TfrSignUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports